import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import IntroCurtain from './components/layout/IntroCurtain';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import FloatingContact from './components/layout/FloatingContact';
import ScrollManager from './components/layout/ScrollManager';

import Home from './pages/Home';
import NotFound from './pages/NotFound';
import { PRIVACY_PATH, TERMS_PATH } from './data/legalRoutes';

// The legal documents are a lot of text that almost no visitor reads. Split
// them out so the showroom page does not carry them.
const PrivacyPage = lazy(() => import('./pages/Legal').then((m) => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import('./pages/Legal').then((m) => ({ default: m.TermsPage })));

/** Holds the header's height while a legal page is being fetched. */
const PageFallback = () => <div className="min-h-[70vh]" aria-busy="true" />;

export default function App() {
  return (
    <>
      <ScrollManager />
      {/* The brand sting belongs to the front door, not to a legal page. */}
      <Routes>
        <Route path="/" element={<IntroCurtain />} />
        <Route path="*" element={null} />
      </Routes>

      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[110] focus:rounded-sm focus:bg-ink-950 focus:px-5 focus:py-3 focus:text-sm focus:text-canvas"
      >
        Skip to content
      </a>

      <Header />

      <main id="main">
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path={PRIVACY_PATH} element={<PrivacyPage />} />
            <Route path={TERMS_PATH} element={<TermsPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>

      <Footer />
      <FloatingContact />
    </>
  );
}
